import React, { useState } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const mapContainerStyle = {
  height: '460px',
  width: '100%',
};

const center = {
  lat: 7.89823,
  lng: 98.355965,
};

const mapOptions = {
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: false,
};

const libraries = ['places'];
const placeId = 'ChIJ9XPjLq8xUDARYaI1JiOeTbQ';
const googleMapsUrl =
  'https://www.google.com/maps/place/Amonthanat+Massage/@7.9029261,98.3465686,15.83z/data=!4m6!3m5!1s0x305031af2ee373f5:0xb44d9e232635a261!8m2!3d7.89823!4d98.355965!16s%2Fg%2F11kr5xp2b2?entry=ttu';

function Clients() {
  const [googleRating, setGoogleRating] = useState(null);
  const [googleReviewsCount, setGoogleReviewsCount] = useState(null);

  const handleMapLoad = (map) => {
    if (!window.google?.maps?.places) {
      return;
    }

    const service = new window.google.maps.places.PlacesService(map);

    service.getDetails(
      {
        placeId,
        fields: ['rating', 'user_ratings_total'],
      },
      (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          setGoogleRating(place.rating || null);
          setGoogleReviewsCount(place.user_ratings_total || null);
        }
      }
    );
  };

  return (
    <section id="find-us" className="mx-auto max-w-7xl px-4 py-20 md:px-6">
      <div className="mb-10 text-center" data-aos="fade-up">
        <p className="text-sm font-semibold uppercase tracking-[0.28em] text-stone-500">
          Find Us
        </p>
        <h2 className="mt-4 font-cyclin text-4xl font-bold text-slate-950 md:text-5xl">
          Easy to reach in Kathu, Phuket
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-8 text-stone-700">
          Open every day from 9:00 AM to 9:00 PM. Use the map below to get
          directions directly to Amonthanat Massage.
        </p>
      </div>

      <div className="mb-8 flex flex-wrap items-center justify-center gap-4">
        <a
          href="tel:+66641831185"
          className="rounded-full border border-stone-300 bg-white/85 px-5 py-3 text-base font-semibold text-stone-900 shadow-sm transition hover:bg-white"
        >
          Call: +66 64 183 1185
        </a>

        <a
          href={googleMapsUrl}
          target="_blank"
          rel="noreferrer"
          className="rounded-full border border-amber-200/80 bg-amber-50/85 px-5 py-3 text-base font-semibold text-amber-900 shadow-sm transition hover:bg-amber-100"
        >
          {googleRating && googleReviewsCount
            ? `Google Reviews: ${googleRating.toFixed(1)} / 5 (${googleReviewsCount} reviews)`
            : 'See Google Reviews'}
        </a>
      </div>

      <div
        className="overflow-hidden rounded-[2rem] border border-white/80 bg-white/82 shadow-2xl shadow-stone-900/10 backdrop-blur"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
          libraries={libraries}
        >
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={center}
            zoom={15}
            options={mapOptions}
            onLoad={handleMapLoad}
          >
            <Marker position={center} />
          </GoogleMap>
        </LoadScript>
      </div>

      <div className="mt-6 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <a
          href={googleMapsUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center rounded-full bg-stone-900 px-7 py-4 font-cyclin text-lg font-bold text-white transition hover:bg-stone-800"
        >
          Open in Google Maps
        </a>
        <p className="text-sm font-medium text-stone-500">
          19/8, Soi Bae Hoa, Kathu, Phuket 83120, Thailand
        </p>
      </div>
    </section>
  );
}

export default Clients;
